import Rellax from 'rellax';
window.Rellax = Rellax;
